import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import GalleryPage from './components/GalleryPage';
import TributePage from './components/TributePage';
import ContactForm from './components/ContactForm';
import ApplyPage from './components/Apply';
import NotFoundPage from './components/NotFoundPage';
import WeatherStationPage from './components/WeatherStationPage';
import EventsPage from './components/EventsPage';
import { WEATHER_STATION_ENABLED } from './config/featureFlags';

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-garden-pattern bg-cover bg-center bg-no-repeat bg-fixed min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/tribute" element={<TributePage />} />
            <Route path="/contact" element={<ContactForm />} />
            <Route path= "/apply" element={<ApplyPage />} />
            {WEATHER_STATION_ENABLED && (
              <Route path="/weather-station" element={<WeatherStationPage />} />
            )}
            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
